import React from 'react';

import { Button, Col, message, Popconfirm, Popover, Row } from 'antd';

import HoldingListController from '../quotation/add-quotation-modal/holding-list-controller';

import { 
	_getAdditionalChargeHoldingList, 
	
	_postConfirmAdditionalCharge,
	_postMakeHoldingListForAdditionalCharge 
} from '../../services';

class AdditionalChargeButton extends React.Component{

	state = {
		additionalChargePopoverVisible: false,
		holdingList: null,
		showPopConfirmSendInvoice: false
	}

	render(){

		if( !this.state.holdingList ){
			return (
				<Popconfirm 
					placement="bottom" 
					title={"Are you sure? This will be logged."} 
					onConfirm={ this.handleConfirmAddAddAdditionalCharge } 
					okText="Yes" 
					cancelText="No">

					<Button>
						Additional Charges
					</Button>
				</Popconfirm>
			)
		}
		// this.closeAdditionalChargePopover
		return (
			<Popover
				visible={this.state.additionalChargePopoverVisible}
				content={(
					<div style={{ width: 700, height: 400, overflowY: "scroll" }}>

						<HoldingListController 
							updateHoldingListProduct={this.updateHoldingListProduct}
							selectedListId={this.state.holdingList._id}
							holdingList={this.state.holdingList}
							/>

						<Row justify="end" type="flex">
							<Col>
								<Popconfirm onCancel={ () => this.setState({ showPopConfirmSendInvoice: false }) } visible={this.state.showPopConfirmSendInvoice && !this.state.holdingList.cartCheckedOut} title="Confirm? This will trigger a new order." onConfirm={this.handleConfirmAdditionalCharge}>
									<Button onClick={() => this.setState({ showPopConfirmSendInvoice: true })} disabled={this.state.holdingList.cartCheckedOut}>
										Confirm Additional Charge
									</Button>
								</Popconfirm>
							</Col>
						</Row>

					</div>
				)}
				trigger="click">

				<Button
					onClick={ () => this.setState({ additionalChargePopoverVisible: !this.state.additionalChargePopoverVisible })}>
					Additional Charges
				</Button>

			</Popover>
		)

	}

	componentWillMount(){

		const { cartId } = this.props;

		_getAdditionalChargeHoldingList({ cartId })
			.then( res => {
				
				this.setState({
					holdingList: res.data.holdingList
				});

			})

	}

	handleConfirmAddAddAdditionalCharge = () => {

		message.loading("Adding a holding list..");
		const { cartId } = this.props;

		_postMakeHoldingListForAdditionalCharge({ cartId })
			.then( (res) => {
				
				message.destroy();

				message.success("Created holding list for additional charges. You may now add custom products.");

				this.setState({
					additionalChargePopoverVisible: true,
					holdingList: res.data.holdingList
				});

			})

	}

	handleConfirmAdditionalCharge = () => {

		message.loading("Sending invoice..");
		
		_postConfirmAdditionalCharge({
			holdingListId: this.state.holdingList._id
		})
			.then( res => {

				message.success("Invoice Sent Successfully!");

				this.setState({ holdingList: res.data.holdingList })

			})

	}

	updateHoldingListProduct = (holdingListId, products ) =>{
    
    this.setState({
      holdingList: {
				...this.state.holdingList,
				products
			}
    })


  }

}

export default AdditionalChargeButton;


// WEBPACK FOOTER //
// ./src/components/orders-v2/additional-charge-button.js